import "./NavigationBar.scss";
import { Container, Stack } from "@mui/material";
import logo from "assets/images/logo-white.svg";
import AuthService from "services/auth.service";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa";
import BasicMenu from "components/atoms/BasicMenu";
import { useAppSelector } from "redux/hooks";

export default function NavigationBar() {
  const user = useAppSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (pathname === "/") return <></>;

  return (
    <header>
      <div className="navbar__container">
        <Container>
          <ul>
            <li>
              <div className="logo">
                <img
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/dashboard")}
                  src={logo}
                  alt="logo"
                />
              </div>
            </li>

            {["Admin", "Dashboard_Viewer", "Product_Manager"].includes(
              user?.role
            ) && (
              <li>
                <Link
                  to="/dashboard"
                  className={`${pathname === "/dashboard" ? "active" : ""}`}
                >
                  Dashboard
                </Link>
              </li>
            )}

            {["Admin", "Product_Manager"].includes(user?.role) && (
              <>
                <li>
                  <Link
                    to="/product-management"
                    className={`${
                      pathname === "/product-management" ? "active" : ""
                    }`}
                  >
                    Products
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category-management"
                    className={`${
                      pathname === "/category-management" ? "active" : ""
                    }`}
                  >
                    Category
                  </Link>
                </li>
                <li>
                  <Link
                    to="/subcategory-management"
                    className={`${
                      pathname === "/subcategory-management" ? "active" : ""
                    }`}
                  >
                    Sub-Category
                  </Link>
                </li>
              </>
            )}

            {["Admin"].includes(user?.role) && (
              <>
                <li>
                  <Link
                    to="/active-orders"
                    className={`${
                      pathname === "/orders" ||
                      pathname === "/active-orders" ||
                      pathname === "/failed-orders" ||
                      pathname === "/today-orders"
                        ? "active"
                        : ""
                    }`}
                  >
                    Orders
                  </Link>
                </li>

                <li>
                  <Link
                    to="/home-page-banner"
                    className={`${
                      pathname === "/home-page-banner" ? "active" : ""
                    }`}
                  >
                    Banners
                  </Link>
                </li>

                <li>
                  <Link
                    to="/account-management"
                    className={`${
                      pathname === "/account-management" ||
                      pathname === "/accounts-with-most-orders"
                        ? "active"
                        : ""
                    }`}
                  >
                    Users
                  </Link>
                </li>
                {/* <li>
              <Link to="/accounts-with-most-orders">Hot Buyers</Link>
            </li> */}

                <li>
                  <Link
                    to="/brand-management"
                    className={`${
                      pathname === "/brand-management" ? "active" : ""
                    }`}
                  >
                    Brands
                  </Link>
                </li>
                <li>
                  <Link
                    to="/deals-management"
                    className={`${
                      pathname === "/deals-management" ? "active" : ""
                    }`}
                  >
                    Deals
                  </Link>
                </li>

                <li>
                  <Link
                    to="/campaigns"
                    className={`${pathname === "/campaigns" ? "active" : ""}`}
                  >
                    Campaigns
                  </Link>
                </li>
              </>
            )}

            <li>
              <BasicMenu
                list={[
                  ...(["Admin", "Product_Manager"].includes(user?.role)
                    ? [
                        {
                          text: (
                            <Link
                              to="/delivery-fee"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                cursor: "pointer",
                                pointerEvents: "auto",
                              }}
                              className="no-link-styles"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/delivery-fee");
                              }}
                            >
                              Delivery Fee
                            </Link>
                          ),
                        },
                        {
                          text: (
                            <Link
                              to="/popular-searches"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                cursor: "pointer",
                                pointerEvents: "auto",
                              }}
                              className="no-link-styles"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/popular-searches");
                              }}
                            >
                              Search Terms
                            </Link>
                          ),
                        },
                        {
                          text: (
                            <Link
                              to="/inventory"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                cursor: "pointer",
                                pointerEvents: "auto",
                              }}
                              className="no-link-styles"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/inventory");
                              }}
                            >
                              Inventory
                            </Link>
                          ),
                        },
                      ]
                    : []),

                  ...(["Admin"].includes(user?.role)
                    ? [
                        {
                          text: (
                            <Link
                              to="/faq-items"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                cursor: "pointer",
                                pointerEvents: "auto",
                              }}
                              className="no-link-styles"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/faq-items");
                              }}
                            >
                              Faq Items
                            </Link>
                          ),
                        },
                        {
                          text: (
                            <Link
                              to="/send-push-notification"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                cursor: "pointer",
                                pointerEvents: "auto",
                              }}
                              className="no-link-styles"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/send-push-notification");
                              }}
                            >
                              Notifications
                            </Link>
                          ),
                        },
                        {
                          text: (
                            <Link
                              to="/product-analytics"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                cursor: "pointer",
                                pointerEvents: "auto",
                              }}
                              className="no-link-styles"
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/product-analytics");
                              }}
                            >
                              Product Analytics
                            </Link>
                          ),
                        },
                      ]
                    : []),

                  {
                    text: (
                      <a
                        href={process.env.REACT_APP_SCHEDULING_DASHBOARD_URL}
                        style={{
                          textDecoration: "none",
                          color: "inherit",
                          cursor: "pointer",
                          pointerEvents: "auto",
                        }}
                        className="no-link-styles"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Scheduling Dashboard
                      </a>
                    ),
                  },
                  {
                    text: "Logout",
                    onClick: () => AuthService.logout(),
                  },
                ]}
                avatar={false}
                color="#ffffff"
              >
                <Stack direction="row" alignItems="center" columnGap={1}>
                  <Link
                    to="#"
                    className={`${
                      pathname.includes("/delivery-fee") ||
                      pathname.includes("/popular-searches") ||
                      pathname.includes("/inventory") ||
                      pathname.includes("/faq-items") ||
                      pathname.includes("/send-push-notification")
                        ? "active"
                        : ""
                    }`}
                  >
                    Settings
                  </Link>
                  <FaAngleDown />
                </Stack>
              </BasicMenu>
            </li>
          </ul>
        </Container>
      </div>
    </header>
  );
}
